import { AdmissionGuideStruct } from "../../structs/private-billing/admission-guide.struct";

export class AdmissionGuideRequest {
    public admissionGuideStruct: AdmissionGuideStruct;
}